import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { isValidElement, cloneElement } from 'react';

function deepMap(children, fn) {
  var _context;

  var processChild = function processChild(child) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var returnChild = child;

    if (! /*#__PURE__*/isValidElement(returnChild)) {
      return returnChild;
    }

    if (returnChild.props.children) {
      returnChild = /*#__PURE__*/cloneElement(returnChild, {
        key: i,
        children: deepMap(returnChild.props.children, fn)
      });
    }

    return fn(returnChild);
  };

  if ( /*#__PURE__*/isValidElement(children)) {
    return processChild(children);
  }

  return _mapInstanceProperty(_context = React.Children).call(_context, children, processChild);
}

export { deepMap };
